<style src="./LostAllItems.scss" lang="scss"></style>
<template>
  <aside class="lost-all-items">
    <span class="title">Perdemos todos os items</span>
    <span class="description">
      Informe a empresa utilizando o campo abaixo
    </span>
    <suggest-distribuitor
      label="Distribuidora"
      placeholder="DISTRIBUIDORA"
      v-model="distributor"
      @selected="selectDistributor"
      class="suggest" />

    <div class="commands">
      <button
        class="cp1-small-button cp1-button__ghost"
        type="button"
        @click="closeWindow">
        Cancelar
      </button>
      <button
        class="cp1-small-button cp1-button__warning m-l"
        type="button"
        @click="setLostItems">
        Definir como perdedora
      </button>
    </div>
  </aside>
</template>

<script>
import { IconUpload, IconWait } from '@/components/primitives/icons'
import { SuggestDistribuitor } from '@/components/primitives'

export default {
  name: 'LostAllItems',
  components: {
    IconUpload,
    IconWait,
    SuggestDistribuitor
  },
  data: () => {
    return {
      distributor: null,
      distributorId: null
    }
  },
  methods: {
    selectDistributor (distributor) {
      this.distributorId = distributor.source._id
    },
    async setLostItems () {
      if (!this.distributorId) {
        this.$toasted.error('É preciso selecionar uma empresa')
        return
      }

      try {
        const payload = {
          eventId: this.$route.params.id,
          stageId: this.$store.getters['Board/STAGE_BY_NAME']('Resultado'),
          distributorId: this.distributorId,
          total: 0,
          distributorName: this.distributor
        }
        await this.$store.dispatch('Result/SET_DEFAULT_DISTRIBUTOR', payload)
        this.$toasted.success('Resultado salvo com sucesso')
      } catch (error) {
        this.$toasted.error('Resultado não pode ser salvo')
      }
    },
    closeWindow () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-result/components/lost-all-items/LostAllItems.vue